import { Platform } from 'react-native'

const createHoverMonitor = () => {
  let isHoverEnabled = false
  let lastTouchTime = 0

  function enableHover () {
    if (isHoverEnabled || Date.now() - lastTouchTime < 500) {
      return
    }
    isHoverEnabled = true
  }

  function disableHover () {
    lastTouchTime = new Date()
    if (isHoverEnabled) {
      isHoverEnabled = false
    }
  }

  if (Platform.OS === 'web') {
    document.addEventListener('touchstart', disableHover, true)
    document.addEventListener('mousemove', enableHover, true)
  }

  return {
    get: () => isHoverEnabled
  }
}

export default createHoverMonitor
